import React from 'react';

const NoMatch = () => {
    return (
        <div>
            <h2>Sorry !!! You are in Wrong Path</h2>
        </div>
    );
};

export default NoMatch;